import { ExternalLink } from "lucide-react";
import styles from "../../styles/portfolioManagerDashboard.module.scss";

// routeMap mirrors useNavigation.js - kept separate because opening in a new tab must build a
// plain URL rather than pushing to this tab's history.
const ROUTE_MAP = {
  Clients: "clients",
  Portfolios: "portfolio",
  Programs: "program",
  Projects: "projects",
};

function EntityNameLink({ name, entityType, entityId, className = "" }) {
  const routePath = ROUTE_MAP[entityType];
  const clickable = Boolean(routePath && entityId);

  const openInNewTab = (e) => {
    e.stopPropagation();
    if (!clickable) return;
    window.open(`${window.location.origin}/${routePath}/${entityId}/overview`, "_blank", "noopener,noreferrer");
  };

  return (
    <span className={`${styles.entityNameLink} ${className}`}>
      <span className={styles.entityNameLinkText}>{name}</span>
      {clickable && (
        <ExternalLink
          size={13}
          color="#342C82"
          className={styles.entityNameLinkIcon}
          onClick={openInNewTab}
        />
      )}
    </span>
  );
}

export default EntityNameLink;
